module.exports = __webpack_public_path__ + "img/395355be2c68447fa91d54d2c64bc939-640.d3c98518.jpg";